/**
 * @fileoverview GET handler for the "/deliverability/postmaster/:app_group_id/domains" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryFetcherAdapter } from "../reactQueryFetcherAdapters";

import { deliverabilityPostmasterAppGroupIdDomains } from "./constants";
import type { DeliverabilityPostmasterAppGroupIdDomainsResult } from "./types";

export const getDeliverabilityPostmasterAppGroupIdDomains = reactQueryFetcherAdapter(
  deliverabilityPostmasterAppGroupIdDomains,
  (signal: AbortSignal, appGroupId: string): Promise<DeliverabilityPostmasterAppGroupIdDomainsResult> => {
    return fetch(`/deliverability/postmaster/${appGroupId}/domains`, "GET", {}, { signal });
  }
);
